import { useState } from 'react';
import ClientTypeFilter from './ClientTypeFilter';
import ClientProductFilter from './ClientProductFilter';
import ClientGymMembershipFilter from './ClientGymMembershipFilter';
import ClientNameFilter from './ClientNameFilter';
import ClientMembershipTypeFilter from './ClientMembershipTypeFilter';
import GymNameFilter from './GymNameFilter';
import ClientStatusesFilter from './ClientStatusesFilter';

const Filters = ({
  classPasses,
  personalTrainings,
  gymMemberships,
  allClientStatuses,
  onFilter,
  membershipProducts,
  gymNameFilter,
  hideStatusFilter,
  membershipType
}) => {
  const [filter, setFilter] = useState({});

  const setProductFilter = (productFilter) => {
    const updatedFilter = {
      ...filter,
      productFilter
    };
    setFilter(updatedFilter);
    onFilter(updatedFilter);
  };

  const setMembershipsStatusFilter = (gymMembershipsStatusFilter) => {
    const updatedFilter = {
      ...filter,
      gymMembershipsStatusFilter
    };
    setFilter(updatedFilter);
    onFilter(updatedFilter);
  };

  const setGymMembershipFilter = (gymMembershipFilter) => {
    const updatedFilter = {
      ...filter,
      gymMembershipFilter
    };
    setFilter(updatedFilter);
    onFilter(updatedFilter);
  };

  const setClassPassFilter = (classPassFilter) => {
    const updatedFilter = {
      ...filter,
      classPassFilter
    };
    setFilter(updatedFilter);
    onFilter(updatedFilter);
  };

  const setPersonalTrainingsFilter = (personalTrainingsFilter) => {
    const updatedFilter = {
      ...filter,
      personalTrainingsFilter
    };
    setFilter(updatedFilter);
    onFilter(updatedFilter);
  };

  const setClientNameFilter = (nameFilter) => {
    const updatedFilter = {
      ...filter,
      nameFilter
    };
    setFilter(updatedFilter);
    onFilter(updatedFilter);
  };

  const setGymNameFilter = (gymNameFilter) => {
    const updatedFilter = {
      ...filter,
      gymNameFilter
    };
    setFilter(updatedFilter);
    onFilter(updatedFilter);
  };

  const setClientStatusesFilter = (statusFilter) => {
    const updatedFilter = {
      ...filter,
      statusFilter
    };
    setFilter(updatedFilter);
    onFilter(updatedFilter);
  };

  return (
    <div className="filterContainer ">
      <div className="md:gridAutoCols md:items-start ">
        <ClientGymMembershipFilter onFilter={setGymMembershipFilter} filters={gymMemberships} title="Gym Membership" />
        <ClientProductFilter onFilter={setClassPassFilter} filters={classPasses} title="Class Passes" />
        <ClientProductFilter
          onFilter={setPersonalTrainingsFilter}
          filters={personalTrainings}
          title="Personal Training"
        />
      </div>
      <div className="block md:gridAutoCols md:items-start ">
        {!hideStatusFilter && (
          <ClientStatusesFilter onFilter={setClientStatusesFilter} allClientStatuses={allClientStatuses} />
        )}
        {membershipProducts && <ClientTypeFilter onFilter={setProductFilter} />}
        {membershipType && <ClientMembershipTypeFilter onFilter={setMembershipsStatusFilter} />}
        <ClientNameFilter onFilter={setClientNameFilter} />
        {gymNameFilter && <GymNameFilter onFilter={setGymNameFilter} />}
      </div>
    </div>
  );
};

export default Filters;
